import { GearIcon as PhosphorGearIcon } from "@phosphor-icons/react/dist/ssr/Gear";

import { createAppIcon } from "@/components/createAppIcon";

export const SettingsIcon = /* @__PURE__ */ createAppIcon(PhosphorGearIcon);
